import {FunctionNameConfig} from "./function.name.config";
import {Stage} from "./stage";

export class FunctionNameResolver {
    resolve(functionNameConfig: FunctionNameConfig, stage: Stage) {
        return `${functionNameConfig.serviceName}-${stage}-${functionNameConfig.nameSuffix}`;
    }
}
